export default "__VITE_ASSET__CESJsnmX__"